/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=b3fe69b8&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=b3fe69b8&lang=css"

import exportComponent from "D:\\www\\wb127_shangrao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__